import styled from "styled-components";
import { colors } from "../../utils";
import Accordion from "@mui/material/Accordion";
import TextView from "../TextView";

export const SideBarOpened = styled.div`
  width: 20vw;
  height: 86vh;
  background-color: ${colors.white};
  border-radius: 10px;
`;

export const SideBarHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 8vh;
  padding-left: 14px;
  border-bottom: 1px solid rgb(225, 225, 225);
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SideBarContent = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  height: 79vh;
  padding-left: 15px;
  padding-top: 15px;
`;

export const MenuItem = styled(Accordion)`
  margin-top: 0px;
  box-shadow: none;
  border: none;
  outline: none;
`;

export const MenuItemHeader = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  height: 48px;
  background-color: #F6F7F9;
  color: red;
  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: ${colors.PrimaryPurple100};
    box-shadow: -3px 0px 0px 0px #8126DB inset;
    `
  }
  p {
   color: ${({ isSelected }) => (isSelected ? colors.PrimaryPurple800 : colors.textSecondary)}; 
  }
`;

export const MenuItemIcon = styled.img`
  width: 16px;
  height: 16px;
  color: ${colors.darkGrey};
  transform: rotate(270deg);
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
`;

export const SideBarIcon = styled.img`
  width: 30px;
  height: 30px;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
`;

export const CenterWrapper = styled.div`
  background-color: ${colors.white};
  margin: 1px;
  padding-left: 3vw;
  padding-top: 2vw;
  padding-right: 3vw;
  width: 85%;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  border-radius: 8px;
`;

export const TabContent = styled.div`
  height: 70vh;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, and Edge */
  }
`

export const InputRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;
`;

export const Input = styled.input`
  width: 100%;
  background-color: ${colors.background};
  border-radius: 5px;
  height: 36px;
  outline: none;
  border: none;
  padding: 5px 10px;
  margin-top: 5px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  background-color: ${colors.background};
  border-radius: 5px;
  height: 100px;
  outline: none;
  border: none;
  padding: 5px 10px;
  margin-top: 5px;
`;

export const ImagePlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${colors.background};
  overflow: hidden;
  margin-bottom: 16px;
  margin-top: 5px;
`;

export const UserImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const Error = styled(TextView)`
  color: ${colors.error};
  position: absolute;
  margin-top: -24px;
`;

export const Item = styled.div``;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px
`

export const SubHeading = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  color: #8F38EF;
`
export const PointContainer = styled.ul`
  padding-left: 1rem;
`

export const Point = styled.li`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const StyledLink = styled.span`
  color: #8F38EF;
  text-decoration: underline;
  cursor: pointer;
`